import { NgModule } from '@angular/core';

const primeNgModules = [];

@NgModule({
  imports: [...primeNgModules],
  exports: [...primeNgModules],
})
export class PrimeNgModule {}
